import styled from "styled-components";
import { Collapse } from "antd";

export const CollapsedSearchResult = styled(Collapse)`
  background-color: #f6f6f6;
  margin-top: 24px;

  &.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 8px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #1070b6;
    font-weight: bold;
    font-size: 15px;
  }

  &.ant-collapse-borderless
    > .ant-collapse-item
    > .ant-collapse-content
    > .ant-collapse-content-box {
    padding: 0px 0px 16px;
  }

  &.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
    overflow: visible;
  }

  &.ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    position: relative;
    left: 0px;
    color: #1070b6;
    font-size: 16px;
    transform: scaleX(1.5);
    transition: transform 0.24s;
    margin-right: 12px;
    top: 50%;
    padding: 0px;
  }

  &.ant-collapse
    > .ant-collapse-item.ant-collapse-item-active
    > .ant-collapse-header
    .ant-collapse-arrow {
    transform: scaleY(1.5) rotate(90deg);
  }
  &.ant-collapse-borderless > .ant-collapse-item {
    border-bottom: 2px solid #1070b6;
  }
`;

// Dummy component to circumvent eslint's error
// that occurs when using a single export const in a module
export const DummyComponent = styled.div``;
